import { frontendURL } from 'dashboard/helper/URLHelper.js';

import CarListingsPageRouteView from './CarListingsPageRouteView.vue';
import CarListingsPage from './CarListingsPage.vue';
import CarListingEditorPage from './editor/CarListingEditorPage.vue';
import CarListingSettingsPage from './CarListingSettingsPage.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/wgpt-car-listings'),
      component: CarListingsPageRouteView,
      children: [
        {
          path: '',
          name: 'wgpt_car_listings_index',
          meta: {
            permissions: ['administrator'],
          },
          component: CarListingsPage,
        },
        {
          path: 'settings',
          name: 'wgpt_car_listings_settings',
          meta: {
            permissions: ['administrator'],
          },
          component: CarListingSettingsPage,
        },
        {
          path: 'showroom',
          name: 'wgpt_car_listings_showroom_settings',
          meta: { permissions: ['administrator'] },
          component: () => import('./PublicShowroomSettingsPage.vue'),
        },
        {
          path: 'new',
          name: 'wgpt_car_listings_new',
          meta: {
            permissions: ['administrator'],
          },
          component: CarListingEditorPage,
        },
        {
          path: ':listingId',
          name: 'wgpt_car_listings_editor',
          meta: {
            permissions: ['administrator'],
          },
          component: CarListingEditorPage,
        },
      ],
    },
  ],
};
